import {
  Grid, Typography, Container, Card,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useIsMobile } from '@client/hooks/dom.hooks';
import { SignupButton } from './SignupButton';

const useStyles = makeStyles()((theme) => ({
  container: { },
  heading: {
    marginBottom: theme.spacing(3),
  },
  card: {
    [theme.breakpoints.up('md')]: {
      borderRadius: theme.radii.medium,
      borderColor: theme.palette.divider,
      borderStyle: 'solid',
      borderWidth: 1,
      padding: theme.spacing(3),
    },
  },
  leftCard: {
    borderRightColor: theme.palette.divider,
    borderRightStyle: 'solid',
    borderRightWidth: 1,

    [theme.breakpoints.down('md')]: {
      paddingRight: theme.spacing(2),
    },
  },
  topCard: {
    borderBottomColor: theme.palette.divider,
    borderBottomStyle: 'solid',
    borderBottomWidth: 1,

    [theme.breakpoints.down('md')]: {
      paddingBottom: theme.spacing(2),
    },
  },
  rightCard: {
    [theme.breakpoints.down('md')]: {
      paddingLeft: theme.spacing(2),
    },
  },
  bottomCard: {
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(2),
    },
  },
}));

export const Stats = () => {
  const { classes, cx } = useStyles();
  const isMobile = useIsMobile();

  return (
    <Container
      maxWidth="md"
      className={classes.container}
    >
      <Grid
        container
        spacing={4}
        alignItems={isMobile ? 'flex-start' : 'center'}
      >
        <Grid
          item
          xs={12}
          md={6}
        >
          <Typography
            variant={isMobile ? 'h4' : 'h6'}
            className={classes.heading}
          >
            Join thousands of artists and hosts, building a more connected independent arts scene
          </Typography>

          <SignupButton
            id="sda-home-stats-signup-button"
          />
        </Grid>

        {isMobile ? (
          <Grid
            item
            container
            xs={12}
            md={6}
          >
            <Grid
              item
              xs={6}
              className={cx(classes.card, classes.topCard, classes.leftCard)}
            >
              <Typography
                variant="h2"
                color="primary"
              >
                14K+
              </Typography>

              <Typography variant="subtitle1">
                Artists & Hosts
              </Typography>
            </Grid>

            <Grid
              item
              xs={6}
              className={cx(classes.card, classes.topCard, classes.rightCard)}
            >
              <Typography
                variant="h2"
                color="secondary"
              >
                3K+
              </Typography>

              <Typography variant="subtitle1">
                Shows Booked
              </Typography>
            </Grid>

            <Grid
              item
              xs={6}
              className={cx(classes.card, classes.bottomCard, classes.leftCard)}
            >
              <Typography
                variant="h2"
                color="warning"
              >
                170K+
              </Typography>

              <Typography variant="subtitle1">
                Tickets Sold
              </Typography>
            </Grid>

            <Grid
              item
              xs={6}
              className={cx(classes.card, classes.bottomCard, classes.rightCard)}
            >
              <Typography
                variant="h2"
                color="success"
              >
                $3M+
              </Typography>

              <Typography variant="subtitle1">
                Paid to Users
              </Typography>
            </Grid>
          </Grid>
        ) : (
          <Grid
            item
            container
            xs={12}
            md={6}
            spacing={3}
          >
            <Grid
              item
              xs={6}
            >
              <Card className={classes.card}>
                <Typography
                  variant="h2"
                  color="primary"
                >
                  14K+
                </Typography>

                <Typography variant="subtitle1">
                  Artists & Hosts
                </Typography>
              </Card>
            </Grid>

            <Grid
              item
              xs={6}
            >
              <Card className={classes.card}>
                <Typography
                  variant="h2"
                  color="secondary"
                >
                  3K+
                </Typography>

                <Typography variant="subtitle1">
                  Shows Booked
                </Typography>
              </Card>
            </Grid>

            <Grid
              item
              xs={6}
            >
              <Card className={classes.card}>
                <Typography
                  variant="h2"
                  color="warning"
                >
                  170K+
                </Typography>

                <Typography variant="subtitle1">
                  Tickets Sold
                </Typography>
              </Card>
            </Grid>

            <Grid
              item
              xs={6}
            >
              <Card className={classes.card}>
                <Typography
                  variant="h2"
                  color="success"
                >
                  $3M+
                </Typography>

                <Typography variant="subtitle1">
                  Paid to Users
                </Typography>
              </Card>
            </Grid>
          </Grid>
        )}
      </Grid>
    </Container>
  );
};
